import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllOffers, offerSelector, setOffers, setOffersSuccess, offerCardsSelector } from '../../cmsSlice';
import CmsOfferTable from './Offer-Table';
import {
  OFFERS_TYPE,
  OFFER_CREATE,
  OFFER_FILTER,
  OFFER_VIEW,
  STATUS,
} from '../../../../constants/OfferConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_OFFERS,
} from '../../../../constants/RoleConsts';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import ActivationPopupModel from '../../../../shared/activation-popup/Activation-Popup';
import {
  activateOfferDetail,
  deactivateOfferDetail,
  deleteOfferDetail,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import WarningPopup from '../../../../shared/warning-popup/Warning-Popup';
import useOutsideAlerter from '../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  generateConfirmationMessage,
  selectedCheckList,
  ResetFilterList,
} from '../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const OfferList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    offerLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    getOffersType,
  } = props;
  const cmsOffer = useSelector(offerSelector);
  const cmsOfferCards = useSelector(offerCardsSelector);
  const [offerList, setOfferList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [filterDataList, setFilterDataList] = useState(OFFER_FILTER);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    offer: {},
    modalType: '',
    type: '',
  });
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [actionMenuList, setActionMenuList] = useState([]);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(hotelId);
  const [dragEnabled, setDragEnabled] = useState(true);

  useEffect(() => {
    setOfferList((prevList) => {
      return cmsOffer?.map((offer) => {
        const isChecked = selectedCheckList(prevList, offer.id);
        return {
          ...offer,
          isChecked: isChecked,
        };
      });
    });
    setFilteredBaseList(cmsOffer);
    setSearchText('');
    resetFilterDataList();
  }, [cmsOffer]);

  const checkedOffer = offerList?.filter((offer) => offer?.isChecked);
  const selectedOfferListLength = checkedOffer?.length;
  const listOfOfferIds = checkedOffer?.map((item) => item?.id);

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(offerList, 'isChecked');

    const filteredRows = await filteredBaseList.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setOfferList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedOfferListLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setOfferList(filteredBaseList?.length ? filteredBaseList : cmsOffer);
    }
  };

  useEffect(() => {
    updateSelectedModule(offerList, setActionMenuList, setIsAllSelected);
  }, [offerList]);

  const resetFilterDataList = () => {
    OFFER_FILTER[1].subMenu = OFFERS_TYPE;
    OFFER_FILTER[2].subMenu = STATUS;
    setFilterDataList(OFFER_FILTER);
  };
  useEffect(() => {
    resetFilterDataList();
  }, []);

  useEffect(() => {
    if (offerLoader || offerList?.length === 0) return;
    const totalItems = offerList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [offerList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      isFilterApplied.current = false;
      const filterList = [...filterDataList];
      const delaultFilter = filterList.map((data) => {
        let subMenuData = [];
        if (data.subMenu && data.subMenu.length > 0) {
          subMenuData = data.subMenu.map((subMenu) => {
            return { ...subMenu, selected: false };
          });
        }
        return { ...data, subMenu: subMenuData };
      });
      setFilterDataList(delaultFilter);
      onsetPage(0);
      setFilteredBaseList(cmsOffer);
      setOfferList(cmsOffer);
      return true;
    }

    isFilterApplied.current = true;
    const filterIdWithFields = filterDataList
      .filter((initialFilter) => initialFilter.subMenu.length > 0)
      .map((filterItem) => {
        const subMenuFiltersId = filterItem.subMenu
          .filter((fItem) => fItem.selected === true)
          .map((fItemId) => fItemId.id);
        if (subMenuFiltersId.length > 0) {
          return {
            id: subMenuFiltersId,
            field: filterItem.field,
          };
        } else return null;
      })
      .filter((item) => item !== null);
    const filteredRecords = cmsOffer.filter((offer) => {
      const doesFilterSatisfy = filterIdWithFields.map((filter) =>
        filter.id.includes(offer[filter.field]),
      );
      return !doesFilterSatisfy.includes(false);
    });
    onsetPage(0);
    setFilteredBaseList(filteredRecords);
    setOfferList(filteredRecords);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedOfferListLength) {
      setOfferList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.offer);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      warning: false,
      Offer: null,
      modalType: '',
      type: '',
    });
  };

  const onClickRowViewDetails = (offerItem, e, isClassDisabled) => {
    if (isClassDisabled) return onViewToggle(OFFER_VIEW, true, offerItem);
    if (e?.target?.tagName === 'TD') {
      onViewToggle(OFFER_VIEW, true, offerItem);
    }
  };

  const onViewDetails = () => {
    onViewToggle(OFFER_VIEW, true, selectedValue.offer);
  };

  const handleCellMenuClick = (event, offer) => {
    if (selectedOfferListLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: offer.id,
        name: offer.name,
        title: '',
        description: '',
        status: false,
        warning: false,
        anchorEl: event.currentTarget,
        offer,
        isLive: offer?.status === 'Live' || offer?.status === 'Scheduled',
        modalType: '',
        type: '',
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onActiveDeActiveOffer = (e, type) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      name: `${prev.offer.name} ?`,
      title: `Are you sure you want to ${type}`,
      description: `You can ${
        type === 'deactivate' ? 'activate' : 'deactivate'
      } this offer from the kebab menu option`,
      status: true,
      anchorEl: null,
      modalType: 'activeModal',
      type,
    }));
  };

  const onOkClick = async () => {
    resetFilterDataList();
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const payload = { hotelId, id: selectedValue.id };
      selectedValue.type === 'deactivate'
        ? await deactivateOfferDetail(payload, language)
        : await activateOfferDetail(payload, language);
      dispatch(fetchAllOffers(hotelId));
      notificationManager(
        'success',
        `Offer ${selectedValue.type === 'deactivate' ? 'deactivated' : 'activated'} successfully`,
      );
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else notificationManager('danger', `Failed to ${selectedValue.type} offer`);
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteOffer = async () => {
    resetFilterDataList();
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const payload = { hotelId, id: selectedValue.id };
      await deleteOfferDetail(payload, language);
      dispatch(fetchAllOffers(hotelId));
      notificationManager('success', `Offer deleted successfully`);
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) notificationManager('danger', e.graphQLErrors[0].message);
      else notificationManager('danger', `Failed to delete offer`);
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const checkUsageInOfferCards = (offerId) => {
    return cmsOfferCards.some((offerCard) => offerCard.offerId === offerId);
  };

  const onClickDeleteOffer = async () => {
    if (checkUsageInOfferCards(selectedValue.id)) {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'The selected offer cannot be deleted as it is being added to an Offer Card',
        status: false,
        warning: true,
        anchorEl: null,
        modalType: 'warningModal',
        type: 'Delete this ',
      }));
    } else if (selectedValue.isLive) {
      setSelectedValue((prev) => ({
        ...prev,
        description: `This offer is currently ${selectedValue.offer.status} and thus cannot be deleted. In order to delete this offer, deactivate this offer and try again.`,
        status: false,
        warning: true,
        anchorEl: null,
        modalType: 'warningModal',
        type: 'Delete this ',
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed',
        status: true,
        warning: false,
        anchorEl: null,
        modalType: 'deleteModal',
      }));
    }
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleAction = (actionName) => {
    let selectedValue = offerList?.filter((offer) => offer?.isChecked);

    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };
  const dragDisabled = !dragEnabled || offerList?.length <= 1;

  const handleSelectAll = (event) => {
    let setSelectedOfferList = [];
    let actionListName = [];
    let actionName = '';
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    setSelectedOfferList = offerList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });
    setSelectedOfferList?.forEach((action) => {
      if (['Scheduled', 'Live'].includes(action?.status)) {
        actionName = 'Deactivate';
      } else if (['Inactive'].includes(action?.status)) {
        actionName = 'Activate';
      }
      if (!actionListName.includes(actionName) && actionName !== '') {
        actionListName.push(actionName);
      }
    });
    setOfferList([...setSelectedOfferList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !setSelectedOfferList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setOfferList(
      cmsOffer.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionName = '';
    let actionList = [];
    let index = offerList?.findIndex((item) => item?.id === id);
    if (!offerList[index]?.isChecked) {
      offerList[index] = { ...offerList[index], isChecked: true };
    } else {
      offerList[index].isChecked = !offerList[index]?.isChecked;
    }
    setOfferList([...offerList]);

    actionList = offerList?.filter((Offer) => Offer?.isChecked).map((status) => status?.status);

    actionList?.forEach((action) => {
      if (['Scheduled', 'Live'].includes(action)) {
        actionName = 'Deactivate';
      } else if (['Inactive'].includes(action)) {
        actionName = 'Activate';
      }
      if (!actionListName.includes(actionName) && actionName !== '') {
        actionListName.push(actionName);
      }
    });

    const isAllSelected = offerList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Offer',
    listOfOfferIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'OFFER';
      await updateSelectedItemsStatus(
        listOfOfferIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllOffers(hotelId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Offer was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'OFFER';
      await deleteSelectedItems(
        listOfOfferIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllOffers(hotelId));
      notificationManager('success', ' Failed to delete Offers');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Offer',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <SearchBar
        type={OFFER_CREATE}
        buttonName='Add Offer'
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        filterList={filterDataList}
        displayAddOrEdit={
          permissions[RBAC_TYPE_CMS_OFFERS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS ? 'show' : 'hide'
        }
        setFilterDataList={setFilterDataList}
        filteredRecoard={filteredRecords}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={offerList}
        setPlaceHolder={setOfferList}
        globalPlaceHolder={cmsOffer}
        setGlobalPlaceHolder={setOffersSuccess}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Offers'
        module='OFFER'
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setDrag={setDragEnabled}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {offerLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <CmsOfferTable
          page={page}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          handleCellMenuClick={handleCellMenuClick}
          offerList={offerList}
          setOfferList={setOfferList}
          permissions={permissions}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onActiveDeActiveOffer={onActiveDeActiveOffer}
          onClickDeleteOffer={onClickDeleteOffer}
          setVisible={setVisible}
          searchText={searchText}
          setActionMenuList={setActionMenuList}
          actionMenuList={actionMenuList}
          handleSelectAll={handleSelectAll}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          handleCheckboxChange={handleCheckboxChange}
          selectedOfferListLength={selectedOfferListLength}
          cmsOffer={cmsOffer}
          getOffersType={getOffersType}
          dragDisabled={dragDisabled}
        />
      </div>
      {selectedValue.status && selectedValue.modalType === 'activeModal' && (
        <ActivationPopupModel
          activationPopUp={selectedValue}
          cancelButtonName='No'
          okButtonName='Yes'
          onOkClick={() => onOkClick()}
          onActivationPopupActionCancel={handleClose}
        />
      )}
      {selectedValue.status && selectedValue.modalType === 'deleteModal' && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteOffer}
          onDeleteCancel={handleClose}
        />
      )}
      {selectedValue.id && selectedValue.warning && selectedValue.modalType === 'warningModal' && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedOfferListLength} ${
            selectedOfferListLength > 1 ? 'offers' : 'offer'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedOfferListLength}  ${
            selectedOfferListLength > 1 ? 'offers' : 'offer'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
    </div>
  );
};

export default OfferList;
